module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v("Author's Note "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1"
    }
  }, [_vm._v("Part One ✦ Praying in the Dark")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Prologue "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap2"
    }
  }, [_c('b', [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Finding Compline "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _c('br'), _c('i', [_vm._v("Nightfall")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap3"
    }
  }, [_c('b', [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Keep Watch, Dear Lord "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _c('br'), _c('i', [_vm._v("Pain and Presence")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two ✦ The Way of the Vulnerable")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Those Who Weep "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _c('br'), _c('i', [_vm._v("Lament")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Those Who Watch "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _c('br'), _c('i', [_vm._v("Attention")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5")]), _vm._v(" "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Those Who Work "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _c('br'), _c('i', [_vm._v("Restoration")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three ✦ A Taxonomy of Vulnerability")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6")]), _vm._v(" "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Give Your Angels Charge Over Those Who Sleep "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _c('br'), _c('i', [_vm._v("Cosmos and Commonplace")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7")]), _vm._v(" "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Tend the Sick, Lord Christ "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _c('br'), _c('i', [_vm._v("Embodiment")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8")]), _vm._v(" "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Give Rest to the Weary "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _c('br'), _c('i', [_vm._v("Weakness and Silence")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9")]), _vm._v(" "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Bless the Dying "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _c('br'), _c('i', [_vm._v("Ashes")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10")]), _vm._v(" "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Soothe the Suffering "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _c('br'), _c('i', [_vm._v("Comfort")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11")]), _vm._v(" "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Pity the Afflicted "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _c('br'), _c('i', [_vm._v("Relentlessness and Revelation")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p3chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("12")]), _vm._v(" "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Shield the Joyous "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _c('br'), _c('i', [_vm._v("Gratitude and Indifference")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four ✦ Culmination")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p4chap1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("13")]), _vm._v(" "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" And All for Your Love's Sake "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _c('br'), _c('i', [_vm._v("Dawn")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Acknowledgments "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Discussion Questions and Suggested Practices "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Notes "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Also by Tish Harrison Warren "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" Praise for "), _c('i', [_vm._v("Prayer in the Night")]), _vm._v(" "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" About the Author "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")]), _vm._v(" More Titles from InterVarsity Press "), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("✦")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 66
// module chunks = 0